import { ReactGlider } from '../ReactGlider';
import { MintCard, MintCardProps } from './MintCard';
import Box from '@mui/material/Box';
import { useMobile } from 'src/hooks/useMobile';

export type MintCardSwiperProps = { mintCards: MintCardProps[] };

export function MintCardSwiper({ mintCards }: MintCardSwiperProps) {
  const isMobile = useMobile();
  return (
    <>
      {mintCards.length > 4 ? (
        <ReactGlider
          itemWidth={372}
          hasArrows={!isMobile}
          navGradientColor={'primary.verticalInverse'}
        >
          {mintCards.map((mintCard) => (
            <Box key={mintCard.collectionTitle} sx={{ pl: 2 }}>
              <MintCard {...mintCard} eagerLoad={true} />
            </Box>
          ))}
        </ReactGlider>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 32 / mintCards.length,
          }}
        >
          {mintCards.map((mintCard) => {
            return <MintCard key={mintCard.collectionTitle} {...mintCard} />;
          })}
        </Box>
      )}
    </>
  );
}
